// removed by extract-text-webpack-plugin
module.exports = {"numbers":"numbers__3BAIC"};


//////////////////
// WEBPACK FOOTER
// ./routes/numbers/style.css
// module id = miTk
// module chunks = 0